module.exports = __webpack_public_path__ + "img/zh-CN.00d7b6d9.png";